
export default ({
  name,
  first_name: firstName,
  last_name: lastName,
  mothers_last_name: secondLastName,
  username }) => {
  return `${firstName || name || username} ${lastName || ''} ${secondLastName || ''}`
}
